<template>
	<menu-dropdown
		class="menu-dropdown"
		:options="filteredOptions"
		@menu-dropdown:select="handleSelect"
	>
		<dots />
	</menu-dropdown>
</template>

<script setup>
import { toRefs, computed } from 'vue';
import { storeToRefs } from 'pinia';

import {
	StarIcon,
	TrashIcon,
	PencilSquareIcon,
	DocumentDuplicateIcon,
	ArrowDownTrayIcon
} from '@heroicons/vue/24/outline';
import { useBuilder } from '../../store/builder.store';

import Dots from '../../icons/actions/dots.vue';
import MenuDropdown from '../menu-dropdown.vue';


const props = defineProps({
	isCoverLetter: {
		type: Boolean,
		default: false
	},
	isWonFormat: {
		type: Boolean,
		default: true
	},
	isPrimary: {
		type: Boolean,
		default: false
	}
});

const { isCoverLetter, isPrimary } = toRefs(props);

const emit = defineEmits([
	'preview-actions:rename',
	'preview-actions:delete',
	'preview-actions:duplicate',
	'preview-actions:set-primary'
]);

const builderStore = useBuilder();
const { downloadFileObject } = storeToRefs(builderStore);

const isDownloadDisabled = computed(() => {
	return downloadFileObject.value?.uploading || false;
});

const filteredOptions = computed(() => {
	return [
		{ value: 'downloadpdf', label: 'Download PDF', icon: ArrowDownTrayIcon, visible: props.isWonFormat, disabled: isDownloadDisabled.value },
		{ value: 'set-primary', label: 'Set as primary', icon: StarIcon, visible: !isCoverLetter.value && !isPrimary.value },
		{ value: 'set-new-primary', label: 'Replace primary resume', icon: StarIcon, visible: !isCoverLetter.value && isPrimary.value },
		{ value: 'duplicate', label: 'Duplicate', icon: DocumentDuplicateIcon, visible: props.isWonFormat },
		{ value: 'rename', label: 'Rename', icon: PencilSquareIcon, visible: true },
		{ value: 'delete', label: 'Delete', icon: TrashIcon, visible: true },
	].filter((el) => el.visible);
});

const handleSelect = (option) => {
	emit(`preview-actions:${option.value}`);
};
</script>
